import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import {ConnectedRouter} from "connected-react-router";

import RouterComponent from "./components/RouterComponent";
import store, {history} from './store';
import useCheckServerAddress from './hooks/useCheckServerAddress';
import ErrorBoundary from './components/ErrorBoundary';

declare global {
    interface Window { CONFIG: any, VARIABLES: any }
}


const RootComponent = () => {
    useCheckServerAddress();
    
    useEffect(() => {
        const cb = () => false;
        document.addEventListener('dblclick', cb);
                
        return () => document.removeEventListener('dblclick', cb);
    }, []);

    return (
        <ErrorBoundary>
            <Provider store={store}>
                <ConnectedRouter history={history} >
                    <RouterComponent />
                </ConnectedRouter>
            </Provider>
        </ErrorBoundary>
    )
};

ReactDOM.render(<RootComponent />, document.getElementById('root'));
